// Stage 1 go-live (orcha2, Mohammed 26/10/2026): the automatic follow-up emails ship switched off and out of
// sight. Their code stays in; stage 2 turns them back on by setting this to true. While it is false:
// - the "FOLLOW UP" menu section and the "Follow-up Settings" group are not in the menu (App.vue);
// - every follow-up page address goes to the dashboard (router.js, isFollowupEmailPath);
// - an enquiry has no "Follow-up" tab (OppotunityTabsDetails.vue);
// - booking a new quote version never asks "restart follow-ups?" (followupRevision.js);
// - saving a task or event never warns about a follow-up email due (FollowupDueWarning.vue).
// The activity "Create follow-up" (a follow-up task or event, G4/G6) is a different feature and stays.
export const FOLLOWUP_EMAILS_ON = false

// The follow-up email pages: Follow up (going out / sent, and their old addresses), the settings pages
// (emails, steps, bank holidays, enrolment, approval feedback), the approval page and an enquiry's tab.
const FOLLOWUP_EMAIL_PATH = /^\/(followUp|emailsGoingOut|sentFollowupEmails|followupApproval|followupSetting)(\/|$)|^\/enquiries\/[^/]+\/followup\/?$/i

export function isFollowupEmailPath(path) {
  return FOLLOWUP_EMAIL_PATH.test(path || '')
}
